// Copyright (c) 2017 Deere & Company

import DealerHierarchyAccount from './dealer-hierarchy-account';
import t from 'tcomb';

const City = t.struct({
    accounts: t.list(DealerHierarchyAccount, 'DealerHierarchyAccounts'),
    city: t.String,
    id: t.String
}, {
    name: 'City',
    strict: true
});

export const getDefaultState = () => new City({
    accounts: [],
    city: '',
    id: ''
});

export default City;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/city.js